// Archivo auto-generado antes de cada build/start (ver scripts/generateBuildInfo.js). No editar manualmente.
export const BUILD_INFO = {
  "version": "0.1.0",
  "commit": "cee4b13",
  "message": "Versión visible: commit y fecha de despliegue en el pie de página y /version.json",
  "buildDate": "2026-10-05T22:10:52.494Z"
};
